import { UseQueryResult } from "@tanstack/react-query";

import { ApiError } from "@nens/react-query-utils";

// We don't care about the type of the data of the other queries only the metadata (isLoading, isFetching, isError, isSuccess), so we can ignore it.
// But we need to keep the error type consistent, so we can use the error from any of the queries.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IgnoreAny = any;

// Combine multiple queries into one, merging their states
// First one is seen as the "main" query. So the typing of the data and query state is based on that one.
export const combineQueries = <T, E extends ApiError | Error>(
  query: UseQueryResult<T, E>,
  ...restQueries: UseQueryResult<IgnoreAny, E>[]
) => {
  const queries = [query, ...restQueries];
  const isLoading = queries.some((q) => q.isLoading);
  const isFetching = queries.some((q) => q.isFetching);
  const isError = queries.some((q) => q.isError);
  const isSuccess = queries.every((q) => q.isSuccess);
  const error = queries.find((q) => q.isError)?.error;
  const data = query.data;

  const refetch = () => {
    for (const query of queries) {
      query.refetch();
    }
  };

  return {
    data: isSuccess ? data : undefined,
    isLoading,
    isFetching,
    isError,
    isSuccess,
    error,
    refetch,
  } as UseQueryResult<T, ApiError>;
};
